import type { CSSProperties } from 'react';
import styles from './ListView.module.css';
import type { IHamburgerCollectionViewProperties } from './interface';

export enum StyleElement {
    Container = 'Container',
    ItemContainer = 'ItemContainer',
}

const DEFAULTS: Record<StyleElement, CSSProperties> = {
    [StyleElement.Container]: {},
    [StyleElement.ItemContainer]: {},
};

const PROPS_APPLICATOR: Record<
    StyleElement,
    (properties: IHamburgerCollectionViewProperties) => CSSProperties
> = {
    [StyleElement.Container]: (properties: IHamburgerCollectionViewProperties) => ({}),
    [StyleElement.ItemContainer]: (properties: IHamburgerCollectionViewProperties) => ({}),
};

export function classNameForElement(
    element: StyleElement,
    model: IHamburgerCollectionViewProperties,
): string {
    const name = element.toString();
    return styles[name] ?? '';
}

export function styleForElement(
    element: StyleElement,
    properties: IHamburgerCollectionViewProperties,
): CSSProperties {
    const style = { ...DEFAULTS[element], ...PROPS_APPLICATOR[element](properties) };

    return style;
}

export function initializeStaticStyling() {
    const bodyHeight = document.body.scrollHeight;
    const windowHeight = window.innerHeight;
    document.documentElement.style.setProperty(
        '--window-bottom-offset',
        `${bodyHeight - windowHeight}px`,
    );
}
